/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'link': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(8 14)" _stroke="#00272E"><path pid="0" d="M9 3.75C9 4.44 9.597 5 10.333 5h3.334c1.103-.003 1.997-.84 2-1.875v-1.25C15.663.841 14.77.003 13.667 0h-3.334C9.597 0 9 .56 9 1.25"/><path pid="1" d="M7 3.75C7 4.44 6.403 5 5.667 5H2.333c-1.103-.003-1.997-.84-2-1.875v-1.25C.337.841 1.23.003 2.333 0h3.334C6.403 0 7 .56 7 1.25"/><path pid="2" d="M4.333 2.5h7.334"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/link.js